module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    ref: "tabBox",
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 'create-new'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTab('create-new')
      }
    }
  }, [_vm._v("Create new entry point")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'journey-defaults'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTab('journey-defaults')
      }
    }
  }, [_vm._v("Journey defaults")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'all-entry-points'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTab('all-entry-points')
      }
    }
  }, [_vm._v("All entry points")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('create-new-entry-point', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'create-new'),
      expression: "activeTab === 'create-new'"
    }]
  }), _vm._v(" "), (_vm.activeTab === 'journey-defaults') ? _c('journey-defaults') : _vm._e(), _vm._v(" "), (_vm.activeTab === 'all-entry-points') ? _c('all-entry-points', {
    on: {
      "tab-change": function($event) {
        return _vm.setTab($event)
      }
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Entry Points")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Entry Points")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d0cd5848","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/EntryPoints.vue
// module id = wh2l
// module chunks = 1